import ReactDataSheet from 'react-datasheet';
import { GridElement } from './types';
import ValueRenderer = ReactDataSheet.ValueRenderer;
import DataRenderer = ReactDataSheet.DataRenderer;

export function renderValue(cell: GridElement, row: number, col:number, valueRenderer: ValueRenderer<GridElement>) {
  const value = valueRenderer(cell, row, col);
  return value === null || typeof value === 'undefined' ? '' : value;
}

export function renderData(cell: GridElement, row: number, col:number, valueRenderer: ValueRenderer<GridElement>, dataRenderer: DataRenderer<GridElement>) {
  const value = dataRenderer ? dataRenderer(cell, row, col) : null;
  return value === null || typeof value === 'undefined'
    ? renderValue(cell, row, col, valueRenderer)
    : value;
}
